/**
 * Fetch the data from the JSON file in the data requests bucket to be 
 * accessed by an External user
 */

export const GetJSONFileData = async (S3, company, link) => {
  const bucket = process.env.REACT_APP_S3_DATAREQUESTS_BUCKET;
  const jsonKey = `${company}/public/${link}.json`;

  try {
    const s3Response = await S3.getObject({
      Bucket: bucket,
      Key: jsonKey,
    }).promise();

    const jsonData = s3Response.Body.toString('utf-8');
    return JSON.parse(jsonData);
    
  } catch (error) {
    console.error("Did not get data: ", error);
    return null;
  }
};
